@if (model$ | async; as model) {
    <div class="container">
        <h2 class="search-result-header" id="search-result-header">
            {{
                (model.pagination.totalResults === 0 ? 'productList.noResultsFor' : 'productList.resultsFor')
                    | cxTranslate: { freeTextSearch: model?.freeTextSearch }
            }}
        </h2>
        @if (model.pagination.totalResults > 0) {
            <div class="search-result-instructions">
                <cx-page-slot position="Section3"></cx-page-slot>
            </div>
        }
        @if (model.pagination.totalResults === 0) {
            <p>
                {{ 'productList.noResults.text' | cxTranslate: { freeTextSearch: model?.freeTextSearch } }}
                <span id="noResultsCategoryLink" class="btn-link text-md" (click)="openRootCategory()">
                    {{ 'productList.noResults.link' | cxTranslate }}
                </span>
            </p>
        }

        @if (categoryLevel2Title$ | async; as categoryLevel2Title) {
            <p class="category-level-2-title">
                {{ 'aimo.selected.level2facet' | cxTranslate }}
                <b class="mr-1">
                    {{ categoryLevel2Title }}
                </b>
                @if (getBackLinkFacet() | async; as backLink) {
                    <a [routerLink]="['/search']" [queryParams]="{ query: backLink.query.query.value }">
                        {{ 'aimo.selected.level2facetBacklink' | cxTranslate }}
                    </a>
                }
            </p>
        }

        @if (facets$ | async; as facet) {
            <div class="sub-categories-wrapper">
                <div class="sub-categories">
                    <aimo-product-category-facets
                        [showAll]="showAllCategories"
                        [lowestLevelSelected]="isLowestLevelSelected(facet)"
                        (showAllAction)="toggleShowAllCategories($event)"
                        [values]="facet.values"
                        [link]="'/search'"></aimo-product-category-facets>
                </div>
            </div>
        }
    </div>
} @else {
    <div class="container">
        <h2 class="search-result-header">
            {{ 'productList.resultsFor' | cxTranslate: { freeTextSearch: '' } }}
        </h2>
    </div>
}
